import React from 'react'
import Skeleton from '@mui/material/Skeleton'

import { AvatarInfo, Paragraph } from 'components/shared'
import { Wrapper } from './Task.style'

const TaskSkeleton = () => {
  return (
    <Wrapper $loading>
      <Paragraph>
        <Skeleton variant="text" component={'span'} />
      </Paragraph>
      <Paragraph>
        <Skeleton variant="text" component={'span'} width={100} />
      </Paragraph>
      <AvatarInfo>
        <Paragraph>
          <Skeleton variant="text" />
        </Paragraph>
      </AvatarInfo>
    </Wrapper>
  )
}

export default TaskSkeleton
